<template>
  <div class="home">
    <h1>All Destinations</h1>
    <div class="destinations">
      <router-link
        v-for="destination in destinations"
        :key="destination.name"
        :to="{
          name: 'DestinationDetails',
          params: { id: destination.id, slug: destination.slug },
        }"
      >
        <h2>{{ destination.name }}</h2>
        <img
          :src="require(`@/assets/${destination.image}`)"
          :alt="destination.name"
        />
      </router-link>
    </div>
  </div>
</template>

<script>
import sourceData from "@/data";

export default {
  name: "Home",
  components: {},
  data() {
    return {
      destinations: sourceData.destinations,
    };
  },
};
</script>
